import React from 'react';
import { formatISTDateOnly } from '../../utils/dateUtils';

const LiveStampingPaymentJournal = ({ requests, loading, isAdmin, onApprove, onReject }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'approved': return 'bg-green-100 text-green-800';
      case 'rejected': return 'bg-red-100 text-red-800';
      default: return 'bg-yellow-100 text-yellow-800';
    }
  };

  if (loading) {
    return <div className="text-center py-10 text-gray-500">Loading journal...</div>;
  }

  if (!requests || requests.length === 0) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 shadow-sm p-12 text-center text-gray-400 italic">
        No payment history found.
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      <div className="p-4 border-b border-gray-100 flex justify-between items-center">
        <h3 className="font-bold text-gray-800">Payment Journal</h3>
        <span className="text-sm text-gray-500">{requests.length} records</span>
      </div>
      
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 text-xs text-gray-500 uppercase tracking-wider">
            <tr>
              <th className="px-6 py-3 text-left">Date</th>
              {isAdmin && <th className="px-6 py-3 text-left">Client</th>}
              <th className="px-6 py-3 text-left">Reference</th>
              <th className="px-6 py-3 text-left">Amount</th>
              <th className="px-6 py-3 text-left">Status</th>
              <th className="px-6 py-3 text-left">Notes</th>
              {isAdmin && <th className="px-6 py-3 text-center">Actions</th>}
            </tr>
          </thead>
          <tbody className="divide-y divide-gray-100">
            {requests.map((req) => (
              <tr key={req.id} className="hover:bg-gray-50">
                <td className="px-6 py-4 text-sm text-gray-500">
                  {formatISTDateOnly(req.created_at)}
                </td>
                {isAdmin && (
                  <td className="px-6 py-4 text-sm text-gray-900 font-medium">
                    {req.client_name || <span className="text-gray-400 font-mono text-xs">{req.client_id.substring(0, 8)}...</span>}
                  </td>
                )}
                <td className="px-6 py-4 text-sm font-medium text-gray-900">
                  {req.reference}
                </td>
                <td className="px-6 py-4 text-sm font-medium text-gray-900">
                  ₹{req.amount}
                </td>
                <td className="px-6 py-4">
                  <span className={`px-2 py-1 inline-flex text-xs leading-5 font-semibold rounded-full ${getStatusColor(req.status)}`}>
                    {req.status}
                  </span>
                </td>
                <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">
                  {req.notes || '-'}
                </td>
                {isAdmin && (
                  <td className="px-6 py-4 text-center text-sm font-medium">
                    {req.status === 'pending' ? (
                      <div className="flex justify-center space-x-2">
                        <button
                          onClick={() => onApprove(req.id)}
                          className="text-green-600 hover:text-green-900 bg-green-50 px-2 py-1 rounded"
                        >
                          Approve
                        </button>
                        <button
                          onClick={() => onReject(req.id)}
                          className="text-red-600 hover:text-red-900 bg-red-50 px-2 py-1 rounded"
                        >
                          Reject
                        </button>
                      </div>
                    ) : (
                      <span className="text-gray-400 text-xs">-</span>
                    )}
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LiveStampingPaymentJournal;
